import { render, staticRenderFns } from "./PriceMapFormCard.vue?vue&type=template&id=f8ef8ed2"
import script from "./PriceMapFormCard.vue?vue&type=script&lang=js"
export * from "./PriceMapFormCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports